import React from 'react';
import { Select2, Select2Props } from '@economic/taco';
import { t } from '@lingui/macro';
import { EmptyCountry } from '~/app/shared/components/ui/dropdowns/CountryDropdown/types';
import { Country, COUNTRIES } from '~/app/shared/util/utilities/countries';
import { CountryCodes } from '../CountryDropdown/countryCodes';

export function CountryCallingCodeDropdown(props: Omit<Select2Props & { error: string }, 'children'>) {
    return (
        <>
            <Select2 className="w-full" aria-label={t`countries`} emptyValue={EmptyCountry} {...props}>
                {COUNTRIES.map((country: Country) => (
                    <Select2.Option
                        key={`${country.code}#${country.callingCode}`}
                        // TODO this might need to change when doing EC-66499
                        value={`${country.code}#${country.callingCode}`}
                        prefix={
                            country.code !== CountryCodes.NAN ? (
                                <span className={`m-1 fi fi-${country.code.toLowerCase()}`} />
                            ) : undefined
                        }>
                        {country.callingCode ?? ''}
                    </Select2.Option>
                ))}
            </Select2>
            {props.invalid && (
                <span className="h-4 text-xs text-left leading-normal font-normal truncate -mb-4 text-red-500">
                    {props.error}
                </span>
            )}
        </>
    );
}
